import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { filter, switchMap } from 'rxjs';
import { debounce } from '../../../lib/debounce';
import { GalleryThemeService } from '../../../services/gallery-theme.service';
import { GalleryService } from '../../../services/gallery.service';
import { SectionService } from '../../../services/section.service';
import { calcLegacyTheme } from '../../lib/calc-legacy-theme';
import { ThemeSingleColorItemComponent } from '../theme-single-color-item/theme-single-color-item.component';

@Component({
  selector: 'app-theme-layout-background-color-item',
  imports: [ThemeSingleColorItemComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './theme-layout-background-color-item.component.html',
  styleUrl: './theme-layout-background-color-item.component.scss',
})
export class ThemeLayoutBackgroundColorItemComponent {
  private galleryService = inject(GalleryService);
  private galleryThemeService = inject(GalleryThemeService);
  private sectionService = inject(SectionService);
  gallery = input.required<GalleryDto>();
  sections = toSignal(
    toObservable(this.gallery).pipe(
      filter(Boolean),
      switchMap(gallery => this.sectionService.getSections(gallery.id))
    )
  );
  theme = computed(() => {
    if (!this.gallery()) return;
    return this.gallery().theme || calcLegacyTheme(this.gallery());
  });

  updateLayoutBackground(backgroundColor: string) {
    this.galleryService.optimisticUpdateGallery(this.gallery().id, {
      theme: this.galleryThemeService.getLayoutBackgroundChangeParams(this.theme(), backgroundColor),
    });
    this.sections().forEach(section => {
      this.sectionService.optimisticUpdateSection(section, {
        layout_background_color: null,
      });
    });
    this.saveLayoutBackground();
  }

  private saveLayoutBackground = debounce(() => {
    this.galleryService.updateGallery(this.gallery().id, {
      theme: {
        ...this.theme(),
      },
    });
    this.sections().forEach(section => {
      if (section.layout_background_color === null) return;
      this.sectionService
        .updateSection(section, {
          layout_background_color: null,
        })
        .subscribe();
    });
  }, 500);
}
